import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class StartEinreichungNavLink extends NavigationLinkBase {
  public readonly allowedStages = MenuStage.SIGNED_IN;
  constructor() {
    super(
      'START_EINREICHUNG',
      _('menu.label.start_einreichung'),
      `/${AppRoute.StartEinreichung}`,
      _('menu.label.start_einreichung'),
    );
  }
}
